import { Paper } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { ReactNode } from 'react';

interface ContentPaperProps {
  children: ReactNode;
}

export const ContentPaper = ({ children }: ContentPaperProps) => {
  const isDesktop = useIsDesktop();

  return (
    <Paper
      elevation={0}
      sx={{
        width: isDesktop ? '800px' : 'calc(100% - 48px)',
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '654px',
        bgcolor: '#fff',
        borderRadius: '16px',
        border: '1px solid #E7EDFF',
        boxShadow: '0px 2px 20px 0px #3A6EEC1F',
        pt: '24px',
        pr: '24px',
        pb: '40px',
        pl: '24px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {children}
    </Paper>
  );
};
